import ItserveInput from "@/components/forms/ItserveInput";
import ItserveButton from "@/components/forms/ItserveButton";
import axios from "axios";

// --- РЕШЕНИЕ: Создаем настроенный клиент прямо здесь ---
// Он будет автоматически использовать URL из вашего .env файла
const apiClient = axios.create({
  baseURL: process.env.VUE_APP_NEW_API_URL,
  timeout: 120000,
});
// ---------------------------------------------------------

export default {
  components: { ItserveInput, ItserveButton },
  data() {
    return {
      showDialog: false,
      dialogMessage: "",
      dialogSuccessMessage: false,
      formStep: 1,
      isLoadingStatus: true, // ✅ Для индикатора загрузки статуса
      isNoContractError: false,
      isLoginError: false,
      isSuccessfulRegistration: false, // Новый флаг для отслеживания успешной регистрации
      isSuccessfulLogin: false, // Флаг для успешного входа
      indications: {
        ls: this.$route.params.account,
        contract_number: this.$route.params.account, // Автозаполнение
        meter_number: null,
        value1: null, // Добавляем поля для показаний
        value2: null,
        value3: null,
        value4: null,
        first_name: null,
        last_name: null,
        confirm_password: null,
        password: null,
        username: null, // Добавляем поле для логина
      },
    };
  },
  computed: {
    userCredentials() {
      // Приоритет: сохраненные данные для показаний -> данные из основной авторизации
      const savedUsername = localStorage.getItem("savedUsername");
      const savedPassword = localStorage.getItem("savedPassword");

      if (savedUsername && savedPassword) {
        return {
          username: savedUsername,
          password: savedPassword,
        };
      }

      return this.$store.state.Auth.userCredentials;
    },
    meterageZone() {
      return this.$store.state.RegionalEnergy.meterage_zone || 1;
    },
    photoMode: {
      get() {
        return this.$store.state.RegionalEnergy.sendPhoto;
      },
      set(photoMode) {
        this.$store.commit(
          "RegionalEnergy/SET_PHOTO_MODE-INDICATIONS",
          photoMode
        );
      },
    },
    errors() {
      return this.$store.state.Api.errors;
    },
    lastIndicators() {
      return this.$store.state.RegionalEnergy.lastIndicators;
    },
  },
  methods: {
    async sendIndications() {
      this.isLoginError = false; // Сбрасываем флаг ошибки при каждой новой попытке
      this.dialogSuccessMessage = false;
      this.isNoContractError = false;
      this.isLoginError = false;
      this.isSuccessfulLogin = false;

      // Показываем локальный лоадер сразу при нажатии кнопки
      this.isSendingIndications = true;

      try {
        if (this.formStep === 1) {
          await this.performStep1();
        } else if (this.formStep === 3) {
          await this.performStep3();
        } else if (this.formStep === 4) {
          await this.performStep4();
        }
      } finally {
        // Скрываем локальный лоадер после завершения любого шага
        this.isSendingIndications = false;
      }
    },

    async performStep1() {
      // Получаем значение показаний (для однозонного счетчика)
      const reading = this.indications.value1;
      console.log("DEBUG: Значение показаний:", reading);

      // Проверяем, есть ли показания для отправки
      if (reading === null || reading === undefined || reading === "") {
        this.dialogMessage = this.$t(
          "regionalEnergy.sendIndications.enterReadings"
        );
        this.showDialog = true;
        return;
      }

      try {
        // Формируем правильный payload для API
        const payload = {
          ...this.indications,
          username: this.userCredentials.username,
          password: this.userCredentials.password,
          account_id: this.indications.ls,
          reading: String(this.indications.value1),
        };

        // Удаляем ls, оставляем только account_id
        delete payload.ls;

        console.log("DEBUG: Правильный payload для отправки:", {
          username: payload.username,
          password: "***",
          reading: payload.reading,
          account_id: payload.account_id,
        });

        const response = await apiClient.post("send_meter", payload);

        console.log("DEBUG: Received from send_meter:", response.data);
        console.log("DEBUG: Подробный анализ ответа:", response);

        // Выкидываем ошибку, если получили явную ошибку
        if (response.data && response.data.status === "fail") {
          console.log("DEBUG: Получен статус fail:", response.data.message);
          throw new Error(response.data.message);
        }

        // Проверяем различные статусы ответа
        if (response.data) {
          console.log("DEBUG: Проверяем статус:", response.data.status);

          switch (response.data.status) {
            case "no_contract":
              console.log("DEBUG: Обработка no_contract");
              this.dialogMessage = this.$t(
                "regionalEnergy.sendIndications.noContractFound"
              );
              this.dialogSuccessMessage = true;
              this.isNoContractError = true;
              this.showDialog = true;
              break;

            case "contract_exists":
              console.log("DEBUG: Обработка contract_exists");
              this.dialogMessage =
                response.data.message ||
                "Счета найдены, но показания не переданы";
              // Это не успешный результат, но и не ошибка
              this.dialogSuccessMessage = false;
              this.showDialog = true;
              break;

            case "success":
              console.log("DEBUG: Обработка success");
              this.dialogMessage = this.$t(
                "regionalEnergy.sendIndications.sentSuccessfullyFlow"
              );
              this.dialogSuccessMessage = true;
              this.showDialog = true;
              break;

            default:
              console.log("DEBUG: Неизвестный статус:", response.data.status);
              // Для неизвестных статусов показываем сообщение от сервера или стандартное
              this.dialogMessage =
                response.data.message ||
                this.$t("regionalEnergy.sendIndications.unknownError");
              this.dialogSuccessMessage = false;
              this.showDialog = true;
              break;
          }
        } else {
          console.log("DEBUG: Нет данных в ответе");
          this.dialogMessage = this.$t(
            "regionalEnergy.sendIndications.unknownError"
          );
          this.dialogSuccessMessage = false;
          this.showDialog = true;
        }
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || error.message || "";
        console.log("DEBUG: Ошибка при отправке показаний:", errorMessage);

        // Проверяем и статус из ответа, если он есть
        const failStatus = error.response?.data?.status === "fail";
        console.log(
          "DEBUG: Статус ошибки:",
          failStatus,
          error.response?.data?.status
        );

        // Проверка на ошибку логина по тексту сообщения ИЛИ по статусу fail + тексту с "пароль"
        if (
          errorMessage.includes("Логін або пароль") ||
          errorMessage.includes("пароль") ||
          (failStatus && errorMessage.toLowerCase().includes("пароль"))
        ) {
          console.log("DEBUG: Обнаружена ошибка логина/пароля");
          this.isLoginError = true;
          this.formStep = 4; // Устанавливаем шаг 4 (повторный вход)

          // Отложенная установка шага для гарантии переключения
          setTimeout(() => {
            console.log("DEBUG: Повторная установка шага 4 через таймаут");
            this.formStep = 4;
            // Также уведомляем компонент, если он поддерживает это
            if (this.$emit) {
              this.$emit("update-form-step", 4);
            }
          }, 0);

          this.showErrorDialog(
            { response: { data: { message: errorMessage } } },
            this.$t("regionalEnergy.sendIndications.loginOrPasswordIncorrect")
          );
          console.log("DEBUG: Установлен шаг 4, показан диалог ошибки логина");
        } else if (errorMessage.includes("Waiting for selector")) {
          this.formStep = 4;
          this.indications.password = null;
        } else {
          this.showErrorDialog(
            error,
            this.$t("regionalEnergy.sendIndications.errorStep1")
          );
        }
      }
    },

    // Шаг 3: Первый вход (когда нет сохраненных данных)
    async performStep3() {
      const { username, password } = this.indications;

      console.log("DEBUG: Попытка входа с учетными данными:", {
        username,
        password: "***",
      });

      if (!username || !password) {
        this.dialogMessage = this.$t(
          "regionalEnergy.sendIndications.fillAllRegistrationFields"
        );
        this.showDialog = true;
        return;
      }

      try {
        // Формируем payload как при реальной отправке, но с reading: "0"
        const payload = {
          ...this.indications,
          username,
          password,
          account_id: this.indications.ls,
          reading: "0",
        };

        // Удаляем ls, оставляем только account_id
        delete payload.ls;

        console.log("DEBUG: Отправка запроса на проверку учетных данных");

        const response = await apiClient.post("send_meter", payload);

        console.log("DEBUG: Ответ от сервера:", response.data);

        const errorMessage = response.data?.message || "";

        // Проверяем на сообщение "Рахунок знайдено. Показання не передані."
        // Это означает успешную авторизацию - сохраняем данные и показываем форму
        if (errorMessage.includes("Рахунок знайдено")) {
          console.log("DEBUG: Вход успешен, сохраняем учетные данные");

          // Сохраняем учетные данные в localStorage
          localStorage.setItem("savedUsername", username);
          localStorage.setItem("savedPassword", password);

          // Переходим на шаг 1 (форма отправки показаний) без показа диалога
          this.formStep = 1;
          this.isSuccessfulLogin = true;

          // Очищаем поля входа
          this.indications.username = null;
          this.indications.password = null;
        }
        // Проверяем на ошибку "Логін або пароль вказано не вірно"
        else if (errorMessage.includes("Логін або пароль")) {
          console.log("DEBUG: Неверные учетные данные");
          this.dialogMessage = this.$t(
            "regionalEnergy.sendIndications.loginOrPasswordIncorrect"
          );
          this.dialogSuccessMessage = false;
          this.showDialog = true;
        }
        // Для обратной совместимости - если статус "contract_exists"
        else if (response.data && response.data.status === "contract_exists") {
          console.log(
            "DEBUG: Вход успешен (contract_exists), сохраняем учетные данные"
          );

          localStorage.setItem("savedUsername", username);
          localStorage.setItem("savedPassword", password);

          // Переходим на шаг 1 (форма отправки показаний) без показа диалога
          this.formStep = 1;
          this.isSuccessfulLogin = true;

          // Очищаем поля входа
          this.indications.username = null;
          this.indications.password = null;
        } else {
          // Любой другой ответ считаем ошибкой
          this.dialogMessage =
            response.data?.message ||
            this.$t("regionalEnergy.sendIndications.loginOrPasswordIncorrect");
          this.dialogSuccessMessage = false;
          this.showDialog = true;
        }
      } catch (error) {
        console.error("DEBUG: Ошибка при входе:", error);
        const errorMessage =
          error.response?.data?.message || error.message || "";

        this.dialogMessage =
          errorMessage ||
          this.$t("regionalEnergy.sendIndications.loginOrPasswordIncorrect");
        this.dialogSuccessMessage = false;
        this.showDialog = true;
      }
    },

    // Шаг 4: Повторный вход (когда учетные данные неверны)
    async performStep4() {
      // Используем ту же логику, что и для шага 3
      await this.performStep3();
    },

    showErrorDialog(error, defaultMessage) {
      console.error("API Error:", error.response);
      this.dialogMessage =
        (error.response && error.response.data.message) || defaultMessage;
      this.dialogSuccessMessage = false;
      this.showDialog = true;
    },

    handleDialogClose() {
      this.showDialog = false;

      console.log(
        "DEBUG: Обработка закрытия диалога. Текущий шаг:",
        this.formStep,
        "isNoContractError:",
        this.isNoContractError,
        "isLoginError:",
        this.isLoginError,
        "isSuccessfulRegistration:",
        this.isSuccessfulRegistration,
        "dialogSuccessMessage:",
        this.dialogSuccessMessage
      );

      if (this.isNoContractError) {
        // Если счет не найден, показываем форму передачи показаний
        this.isNoContractError = false;
        this.formStep = 1;
        console.log(
          "DEBUG: Счет не найден, показываем форму передачи показаний"
        );
      } else if (this.isSuccessfulLogin) {
        // Если успешно вошли (шаг 3 или 4)
        console.log("DEBUG: Обнаружен успешный вход, переход к шагу 1");
        this.isSuccessfulLogin = false; // Сбрасываем флаг
        this.formStep = 1;

        // Очищаем поля входа
        this.indications.username = null;
        this.indications.password = null;
      } else if (this.isSuccessfulRegistration) {
        // Если успешно завершили регистрацию, показываем форму передачи показаний
        console.log(
          "DEBUG: Обнаружена успешная регистрация, переход к форме передачи показаний"
        );
        this.isSuccessfulRegistration = false;
        this.formStep = 1;

        Object.keys(this.indications).forEach((key) => {
          if (key !== "ls" && key !== "contract_number") {
            this.indications[key] = null;
          }
        });
      } else if (this.isLoginError || this.formStep === 4) {
        // Если ошибка авторизации или мы уже на шаге 4
        // убеждаемся, что мы остаемся на шаге повторного входа
        this.isLoginError = false;
        this.formStep = 4;
        this.indications.password = null;
        console.log("DEBUG: Переход или остаемся на шаге 4 (повторный вход)");

        // Удостоверяемся, что поля для входа доступны пользователю
        setTimeout(() => {
          console.log(
            "DEBUG: Проверка формы через таймаут, шаг:",
            this.formStep
          );
          // Дополнительная гарантия переключения на шаг 4
          this.formStep = 4;
          // Уведомляем компонент о необходимости обновить шаг
          if (this.$emit) {
            this.$emit("update-form-step", 4);
          }

          // Проверяем, что произошло переключение
          if (this.formStep !== 4) {
            console.error(
              "DEBUG: Критическая ошибка: не удалось переключиться на шаг 4"
            );
          }
        }, 0);
      } else if (this.dialogSuccessMessage && this.formStep === 3) {
        // Если успешно вошли на шаге 3, переходим к отправке показаний
        console.log("DEBUG: Успешный вход, переходим к отправке показаний");
        this.formStep = 1;
        // Очистка полей входа, но сохраняем номер счета
        Object.keys(this.indications).forEach((key) => {
          if (key !== "ls" && key !== "contract_number") {
            this.indications[key] = null;
          }
        });

        // Добавляем отложенное обновление для гарантии перехода на шаг 1
        setTimeout(() => {
          console.log(
            "DEBUG: Повторная установка шага 1 через таймаут после входа"
          );
          this.formStep = 1;
          // Также уведомляем компонент о необходимости обновить шаг
          if (this.$emit) {
            this.$emit("update-form-step", 1);
          }

          // Проверяем, что произошло переключение
          if (this.formStep !== 1) {
            console.error(
              "DEBUG: Критическая ошибка: не удалось переключиться на шаг 1 после входа"
            );
          }
        }, 0);
      } else if (this.dialogSuccessMessage) {
        // Другие успешные действия
        console.log("DEBUG: Другое успешное действие, форма шаг 1");
        this.formStep = 1;
        // Очистка полей
        Object.keys(this.indications).forEach((key) => {
          if (key !== "ls") {
            this.indications[key] = null;
          }
        });
      }
    },
  },
};
